import { createFileRoute } from "@tanstack/react-router";
import AdminSettingNewPage from "@/pages/admin/settings/new";
import { useSettingsPermissions } from "@/pages/admin/settings";

export const Route = createFileRoute("/app/admin/settings/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllSettingTags, userCanViewAllSettingTags } = useSettingsPermissions();

  return (
    <AdminSettingNewPage
      userCanEditAllSettingTags={userCanEditAllSettingTags}
      userCanViewAllSettingTags={userCanViewAllSettingTags}
    />
  );
}
